<template>
  <div class="setCenter pointer">
    <NavBar title="设置"></NavBar>
    <div class="settingBox">
      <div class="setting-item">
        <div class="item" @click="toPersonalCenter">
          <div class="item_left">
            <img
              class="ico"
              src="@/assets/icons/tubiao_gerenzhongxin-.png"
              alt=""
            />
            <p class="p1">个人中心</p>
          </div>
        </div>
        <div class="item" @click="toAboutUs">
          <div class="item_left">
            <img class="ico" src="@/assets/icons/guanyuwomen.png" alt="" />
            <p class="p1">关于我们</p>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="item" @click="handleShowDialog">
          <div class="item_left">
            <img class="ico" src="@/assets/icons/logout.png" alt="" />
            <p class="p1">退出登录</p>
          </div>
          <div class="item-r">
            <div class="arrow"></div>
          </div>
        </div>
      </div>
    </div>
    <secondConfirm
      :showDialog.sync="showDialog"
      content="确认要退出登录吗？"
      @affirm="logoutConfim"
    ></secondConfirm>
  </div>
</template>
        <script>
import NavBar from "@/components/NavBar.vue";
import secondConfirm from "@/components/publicDialog/secondConfirm.vue";
import { logout } from "@/api/login";
import { removeToken, removeData } from "@/utils/auth";
import { mapState, mapMutations } from "vuex";
export default {
  name: "SetCenter",
  components: {
    NavBar,
    secondConfirm,
  },
  data() {
    return {
      showDialog: false,
    };
  },
  mounted() {},
  methods: {
    ...mapMutations("user", ["SET_TOKEN", "SET_DATA"]),
    handleShowDialog() {
      this.showDialog = true;
    },
    logoutConfim() {
      logout().then((res) => {
        if (res.code == 200) {
          removeToken();
          removeData();
          this.SET_TOKEN(null);
          this.SET_DATA(null);
          this.$router.push("/login");
        }
      });
    },
    toAboutUs() {
      this.$router.push("/aboutUs");
    },
    toPersonalCenter() {
      this.$router.push("/personalCenter");
    },
  },
};
</script>
        
    <style lang="less" scoped>
.setCenter {
  .settingBox {
    padding: 10px 16px;
    .setting-item {
      width: 100%;
      background: #fff;
      border-radius: 10px;
      color: #333;
      font-size: 14px;
      padding: 0 16px;
      margin-bottom: 12px;

      .item {
        width: 100%;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item_left {
          display: flex;
          align-items: center;
          .ico {
            width: 16px;
            height: 16px;
            margin-right: 12px;
          }
        }
        .item-r {
          color: #999;
          .arrow {
            border-color: #999;
            height: 6px;
            margin-left: 3px;
            margin-right: 2px;
            width: 6px;
            display: inline-block;
            position: relative;
          }
          .arrow:after {
            background-color: inherit;
            border-color: inherit;
            border-style: solid;
            content: "";
            height: inherit;
            left: 0;
            position: absolute;
            top: 0;
            transition: all 0.3s ease;
            width: inherit;
            border-width: 0 0 1px 1px;
            transform: rotate(-135deg);
          }
        }
      }
      .item:not(:last-child) {
        border-bottom: 1px solid #e6e6e6;
      }
    }
  }
}
</style>